import React from "react";

import "./WineShopBanner.css";

function WineShopBanner() {
  return (
    <div className="banner-block">

      <div className="banner-frame-wrapper">
        <iframe
          className="banner-api-frame"
          src="https://gitstool.in/liquor/shop_app/home.html"
          title="DSIIDC LTD. - Online Liquor Booking"
          frameBorder="0"
          scrolling="no"
        />
      </div>

    </div>
  );
}

export default WineShopBanner;